import Keycloak from "keycloak-js";

const keycloakMgr = {
    inst: null,
    hint: '',
    init: function(config) {
        this.hint = config.authHint;
        this.inst =  new Keycloak({
            url: config.authServiceUrl,
            realm: config.authServiceRealm,
            clientId: config.authServiceClientId
        });
    },
    getHint: function() {
        return this.hint;
    },
    get: function() {
        return this.inst;
    },
    addHeader: async function(config) {
        if (this.inst && this.inst.token) {
            if (config.url && config.url.indexOf('cockpit-cdn') > -1) {
                return;
            }
            const token = await this.inst.token;
            config.headers.Authorization = 'Bearer ' + token;
        }
    },
    addHeaderXhr: async function(xhr) {
        if (this.inst && this.inst.token) {
            const token = await this.inst.token;
            xhr.setRequestHeader("Authorization", 'Bearer ' + token);
        }
    }
};

export default keycloakMgr;
